<template>
  <navbar />
  <router-view />
  <bottomBanner />
</template>

<script>
import navbar from "./components/navbar.vue";
import bottomBanner from "./components/footer.vue";

export default {
  components: {
    navbar,
    bottomBanner,
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  overflow: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    /*滾動條外框*/
    background: rgba(150, 150, 150, 0.9);
    /*滾動條顏色*/
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
